import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Divider,
  Link,
  Image,
  Badge,
  cn,
} from "@nextui-org/react";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
} from "@nextui-org/react";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { addDays, format } from "date-fns";

//@ts-ignore
import soundVotacaoIniciada from "../../../assets/sounds/votacao_pauta_iniciada.mp3";
//@ts-ignore
import soundVotacaoFinalizada from "../../../assets/sounds/votacao_pauta_finalizada.mp3";
import {
  initializeVotingArrays,
  getCurrentVotingArray,
  countVotes,
} from "../../../utils/votingUtils";

type infoSolicitarPresenca = {
  sessao: {
    id: string;
    dataSessao: string;
    legislatura: string;
    periodo: string;
    sessao: string;
    statusConfigSessao: number;
    statusSessao: string;
    tipoSessao: string;
  };
};

type RoomParams = {
  id: string;
};

interface Parlamentar {
  id: string;
  nome: string;
  parlamentar: string;
  aprovacao: string;
}

interface PautaVotacao {
  id?: string;
  idPauta?: string;
  numero?: string;
  pautaLegislativa?: string;
  opcoesVotacao?: string;
  statusAtual?: string;
  votos?: Parlamentar[];
  votos1turno?: Parlamentar[];
  votos2turno?: Parlamentar[];
  iniciarVotacao?: boolean;
  encerrarVotacao?: boolean;
}

const ORDEM_MESA_DIRETORA: Record<string, number> = {
  presidente: 0,
  "vice-presidente": 1,
  "1-secretário": 2,
  "2-secretário": 3,
};

const LABEL_MESA_DIRETORA: Record<string, string> = {
  presidente: "PRESI:",
  "vice-presidente": "VICE:",
  "1-secretário": "1º SEC:",
  "2-secretário": "2º SEC:",
};

export function PautasVotacao({ sessao }: infoSolicitarPresenca) {
  const params = useParams<RoomParams>();
  const roomId = params.id;

  const audioRefVotacaoIniciada = useRef(null);
  const audioRefVotacaoFinalizada = useRef(null);

  const [time, setTime] = useState(new Date());
  const [pautasVotacao, setpautasVotacao] = useState<PautaVotacao>({});

  const [votacaopautasParlamentares, setvotacaopautasParlamentares] = useState<
    Parlamentar[]
  >([]);
  const [primeiraParte, setPrimeiraParte] = useState<Parlamentar[]>([]);
  const [segundaParte, setSegundaParte] = useState<Parlamentar[]>([]);
  const [presencaParlamentares, setPresencaParlamentares] = useState([]);
  const [mesaDiretora, setMesaDiretora] = useState<Parlamentar[]>([]);
  const [funcaoPorId, setFuncaoPorId] = useState<Record<string, string>>({});
  const [quantidadeVotosSim, setQuantidadeVotosSim] = useState(0);
  const [quantidadeVotosNao, setQuantidadeVotosNao] = useState(0);
  const [quantidadeVotosAbst, setQuantidadeVotosAbst] = useState(0);

  const simplesOptions = [
    {
      label: "Projeto de resolução",
      value: "projetoResolucao",
    },
    {
      label: "Emenda",
      value: "emenda",
    },
    {
      label: "Indicação",
      value: "indicacao",
    },
    {
      label: "Projeto de Decreto Legislativo",
      value: "projetoDecretoLegislativo",
    },
    {
      label: "Projeto de emenda à Lei orgânica",
      value: "projetoEmendaLeiOrganica",
    },
    {
      label: "Projeto de Lei Ordinária",
      value: "projetoLeiOrdinaria",
    },
    {
      label: "Projeto de Lei do Poder Executivo",
      value: "projetoLeiPoderExecutivo",
    },
    {
      label: "Projeto de Lei do Poder Legislativo",
      value: "projetoLeiPoderLegislativo",
    },
    {
      label: "Projeto Substitutivo",
      value: "projetoSubstitutivo",
    },
    {
      label: "Requerimento",
      value: "requerimento",
    },
    {
      label: "Subemenda",
      value: "subemenda",
    },
    {
      label: "Veto",
      value: "veto",
    },
    {
      label: "Pareceres das Comições",
      value: "pareceresComicoes",
    },
    {
      label: "Parecer",
      value: "parecer",
    },
    {
      label: "Mensagem",
      value: "mensagem",
    },
  ];

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${roomId}`,
      "presencaParlamentares"
    );

    onSnapshot(ordersRef, (querySnapshot) => {
      const parsedData = querySnapshot.docs.map((doc) => {
        const data = doc.data();

        return {
          id: doc.id,
          ...data,
        };
      });

      //@ts-ignore
      setPresencaParlamentares(parsedData);
    });
  }, []);

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (pautasVotacao && Object.keys(pautasVotacao).length !== 0) {
      if (
        //@ts-ignore
        pautasVotacao.iniciarVotacao === true &&
        //@ts-ignore
        pautasVotacao.encerrarVotacao === undefined
      ) {
        //@ts-ignore
        audioRefVotacaoIniciada.current.play();
      }

      if (
        //@ts-ignore
        pautasVotacao.encerrarVotacao === true &&
        //@ts-ignore
        pautasVotacao.iniciarVotacao === true
      ) {
        //@ts-ignore
        audioRefVotacaoFinalizada.current.play();
      }
    }
  }, [pautasVotacao]);

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${roomId}`,
      "pautas"
    );
    const queryRef = query(ordersRef, where("votado", "==", true));

    onSnapshot(queryRef, async (querySnapshot) => {
      const parsedData = querySnapshot.docs.map((doc) => {
        const data = doc.data();

        return { id: doc.id, ...data };
      });

      const resultadosAdicionais: any[] = [];

      // Realizar consultas adicionais para cada documento retornado pela primeira consulta
      await Promise.all(
        parsedData.map(async (docSnapshot) => {
          //@ts-ignore
          const documentoRef = doc(
            db,
            "users",
            "belacruz@eleg",
            "pautas",
            //@ts-ignore
            `${docSnapshot.idPauta}`
          );
          const consultaAdicionalSnapshot = await getDoc(documentoRef);

          const data = {
            //@ts-ignore
            ...consultaAdicionalSnapshot.data(),
            ...docSnapshot,
          };

          resultadosAdicionais.push(data);
        })
      );

      const prioridade = (pauta: any) => {
        if (pauta?.iniciarVotacao === true && pauta?.encerrarVotacao !== true) {
          return 0;
        }
        if (pauta?.iniciarVotacao === true && pauta?.encerrarVotacao === true) {
          return 1;
        }
        return 2;
      };

      resultadosAdicionais.sort((a, b) => prioridade(a) - prioridade(b));

      //@ts-ignore
      setpautasVotacao(resultadosAdicionais[0] || {});
    });
  }, []);

  useEffect(() => {
    if (pautasVotacao?.idPauta) {
      const db = getFirestore();
      const ordersRef = doc(
        db,
        "users",
        "belacruz@eleg",
        "pautas",
        pautasVotacao.idPauta
      );

      onSnapshot(ordersRef, (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          if (!data) {
            setvotacaopautasParlamentares([]);
            return;
          }

          // Usar função utilitária para obter o array de votos correto
          const currentVotes = getCurrentVotingArray(data);
          setvotacaopautasParlamentares(currentVotes);
        } else {
          setvotacaopautasParlamentares([]);
        }
      });
    } else {
      setvotacaopautasParlamentares([]);
    }
  }, [pautasVotacao]);

  useEffect(() => {
    // Reset counts first
    setQuantidadeVotosSim(0);
    setQuantidadeVotosNao(0);
    setQuantidadeVotosAbst(0);

    // Only proceed if we have valid data
    if (
      votacaopautasParlamentares &&
      Array.isArray(votacaopautasParlamentares) &&
      votacaopautasParlamentares.length > 0
    ) {
      votacaopautasParlamentares.forEach((voto) => {
        if (voto && typeof voto === "object") {
          if (voto.aprovacao === "sim") {
            setQuantidadeVotosSim((prev) => prev + 1);
          } else if (voto.aprovacao === "nao") {
            setQuantidadeVotosNao((prev) => prev + 1);
          } else if (voto.aprovacao === "abster") {
            setQuantidadeVotosAbst((prev) => prev + 1);
          }
        }
      });
    }
  }, [votacaopautasParlamentares]);

  useEffect(() => {
    const db = getFirestore();

    const parlamentaresRef = collection(
      db,
      "users",
      "belacruz@eleg",
      "parlamentares"
    );
    const queryRef = query(
      parlamentaresRef,
      where("parlamentarEstado", "==", "ativo")
    );

    getDocs(queryRef).then((querySnapshot) => {
      const funcoes: Record<string, string> = {};
      querySnapshot.docs.forEach((doc) => {
        funcoes[doc.id] = doc.data().funcaoPartidaria;
      });
      setFuncaoPorId(funcoes);
    });
  }, []);

  useEffect(() => {
    if (
      votacaopautasParlamentares &&
      Array.isArray(votacaopautasParlamentares)
    ) {
      const votantesAtivos = votacaopautasParlamentares
        //@ts-ignore
        .filter((item) => funcaoPorId[item.parlamentar] !== undefined);

      const primeiraParteArray = votantesAtivos
        //@ts-ignore
        .filter(
          (item) => ORDEM_MESA_DIRETORA[funcaoPorId[item.parlamentar]] === undefined
        )
        .slice(0, 2);
      const segundaParteArray = votantesAtivos
        //@ts-ignore
        .filter(
          (item) => ORDEM_MESA_DIRETORA[funcaoPorId[item.parlamentar]] === undefined
        )
        .slice(2);

      setPrimeiraParte(primeiraParteArray);
      setSegundaParte(segundaParteArray);

      setMesaDiretora(
        votantesAtivos
          //@ts-ignore
          .filter(
            (item) => ORDEM_MESA_DIRETORA[funcaoPorId[item.parlamentar]] !== undefined
          )
      );
    } else {
      setPrimeiraParte([]);
      setSegundaParte([]);
      setMesaDiretora([]);
    }
  }, [votacaopautasParlamentares, funcaoPorId]);

  //@ts-ignore
  const labelCorrespondente = simplesOptions.find(
    //@ts-ignore
    (opcao) => opcao.value === pautasVotacao?.pautaLegislativa
  );

  return (
    <div className="min-h-screen flex flex-col justify-between p-0 bg-gray-900">
      <audio ref={audioRefVotacaoIniciada}>
        <source src={soundVotacaoIniciada} type="audio/mp3" />
      </audio>

      <audio ref={audioRefVotacaoFinalizada}>
        <source src={soundVotacaoFinalizada} type="audio/mp3" />
      </audio>

      <div>
        <Card className="min-w-[100%] h-22 items-center bg-gray-900 p-0 ">
          <CardHeader className="flex flex-col items-center">
            <h1 className="text-5xl font-extrabold  uppercase text-gray-50">
              Câmara Municipal de Bela Cruz
            </h1>
            <Divider className="bg-amber-300 my-2 h-[8px] " />
            <p className="text-3xl font-sans  text-gray-50 uppercase">
              {/* @ts-ignore */}
              {sessao.sessao} SESSÃO{" "}
              {sessao.tipoSessao === "extraordinaria"
                ? "EXTRAORDINÁRIA"
                : "ORDINÁRIA"}{" "}
              {sessao.periodo === undefined
                ? ""
                : sessao.periodo === "1"
                ? "DO 1° PERÍODO DA LEGISLATURA"
                : "DO 2° PERÍODO DA LEGISLATURA"}{" "}
              ({sessao.legislatura})
            </p>
          </CardHeader>

          <CardFooter className="flex items-center justify-center bg-gray-700">
            <p className="text-3xl font-bold text-white  uppercase">
              {/* @ts-ignore */}
              Nº {pautasVotacao?.numero} - {/* @ts-ignore */}
              {labelCorrespondente?.label} em votação
            </p>
          </CardFooter>
        </Card>
      </div>

      {votacaopautasParlamentares &&
        Array.isArray(votacaopautasParlamentares) && (
          <div className="w-full flex justify-between p-0">
            <div className="w-full flex justify-between p-0 ">
              <div className="w-1/2">
                <Table hideHeader fullWidth className="p-0">
                  <TableHeader>
                    <TableColumn>Nome</TableColumn>
                  </TableHeader>
                  <TableBody>
                    {/* @ts-ignore */}
                    {mesaDiretora &&
                      Array.isArray(mesaDiretora) &&
                      mesaDiretora
                        .sort(
                          (a, b) =>
                            //@ts-ignore
                            (ORDEM_MESA_DIRETORA[funcaoPorId[a.parlamentar]] ?? -1) -
                            //@ts-ignore
                            (ORDEM_MESA_DIRETORA[funcaoPorId[b.parlamentar]] ?? -1)
                        )
                        .map((item, index) => (
                          <TableRow
                            key={index}
                            style={{
                              borderTopColor: "#1F273A",
                              borderTopWidth: index === 0 ? 0 : 2,
                            }}
                          >
                            <TableCell
                              style={{
                                height: 70,
                              }}
                            >
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-4">
                                  <div className="w-10 h-10 border border-white rounded-full p-1">
                                    {
                                      //@ts-ignore
                                      (item as any).aprovacao != undefined && (
                                        <div
                                          className={`w-full h-full ${
                                            (item as any).aprovacao === "sim"
                                              ? "bg-green-500"
                                              : (item as any).aprovacao ===
                                                "nao"
                                              ? "bg-red-500"
                                              : "bg-yellow-400"
                                          } rounded-full`}
                                        />
                                      )
                                    }
                                  </div>

                                  <p
                                    className={`text-2xl font-extrabold uppercase text-yellow-500 `}
                                  >
                                    {
                                      //@ts-ignore
                                      LABEL_MESA_DIRETORA[
                                        funcaoPorId[item.parlamentar]
                                      ]
                                    }
                                  </p>

                                  <p
                                    className={`text-2xl font-extrabold uppercase  ${
                                      (item as any).aprovacao === "sim"
                                        ? "text-green-500"
                                        : (item as any).aprovacao === "nao"
                                        ? "text-red-500"
                                        : "text-yellow-400"
                                    }`}
                                  >
                                    {/* @ts-ignore */}
                                    {item.nome}
                                  </p>
                                </div>

                                <p
                                  className={`text-2xl font-extrabold uppercase ${
                                    (item as any).aprovacao === "sim"
                                      ? "text-green-500"
                                      : (item as any).aprovacao === "nao"
                                      ? "text-red-500"
                                      : "text-yellow-400"
                                  }`}
                                >
                                  {/* @ts-ignore */}
                                  {item.aprovacao == "nao"
                                    ? "Não"
                                    : item.aprovacao}
                                </p>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>

                <Divider className="bg-amber-300 my-[15px] h-[8px] " />

                <Table hideHeader fullWidth className="p-0 ">
                  <TableHeader>
                    <TableColumn>Nome</TableColumn>
                  </TableHeader>
                  <TableBody>
                    {primeiraParte && Array.isArray(primeiraParte)
                      ? primeiraParte.map((item, index) => (
                          <TableRow
                            key={index}
                            style={{
                              borderTopColor: "#1F273A",
                              borderTopWidth: index === 0 ? 0 : 2,
                            }}
                          >
                            <TableCell
                              style={{
                                height: 70,
                              }}
                            >
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-4">
                                  <div className="w-10 h-10 border border-white rounded-full p-1">
                                    {
                                      //@ts-ignore
                                      (item as any).aprovacao != undefined && (
                                        <div
                                          className={`w-full h-full ${
                                            (item as any).aprovacao === "sim"
                                              ? "bg-green-500"
                                              : (item as any).aprovacao ===
                                                "nao"
                                              ? "bg-red-500"
                                              : "bg-yellow-400"
                                          } rounded-full`}
                                        />
                                      )
                                    }
                                  </div>
                                  <p
                                    className={`text-2xl font-extrabold uppercase  ${
                                      (item as any).aprovacao === "sim"
                                        ? "text-green-500"
                                        : (item as any).aprovacao === "nao"
                                        ? "text-red-500"
                                        : "text-yellow-400"
                                    }`}
                                  >
                                    {/* @ts-ignore */}
                                    {item.nome}
                                  </p>
                                </div>

                                <p
                                  className={`text-2xl font-extrabold uppercase ${
                                    (item as any).aprovacao === "sim"
                                      ? "text-green-500"
                                      : (item as any).aprovacao === "nao"
                                      ? "text-red-500"
                                      : "text-yellow-400"
                                  }`}
                                >
                                  {/* @ts-ignore */}
                                  {item.aprovacao == "nao"
                                    ? "Não"
                                    : item.aprovacao}
                                </p>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      : []}
                  </TableBody>
                </Table>
              </div>

              {/* Tabela 2 */}
              <div className="w-1/2">
                <Table hideHeader fullWidth>
                  <TableHeader>
                    <TableColumn>Nome</TableColumn>
                  </TableHeader>
                  <TableBody>
                    {segundaParte && Array.isArray(segundaParte)
                      ? segundaParte.map((item, index) => (
                          <TableRow
                            key={index}
                            style={{
                              borderTopColor: "#1F273A",
                              borderTopWidth: index === 0 ? 0 : 2,
                            }}
                          >
                            <TableCell
                              style={{
                                height: 70,
                              }}
                            >
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-4">
                                  <div className="w-10 h-10 border border-white rounded-full p-1">
                                    {
                                      //@ts-ignore
                                      (item as any).aprovacao != undefined && (
                                        <div
                                          className={`w-full h-full ${
                                            (item as any).aprovacao === "sim"
                                              ? "bg-green-500"
                                              : (item as any).aprovacao ===
                                                "nao"
                                              ? "bg-red-500"
                                              : "bg-yellow-400"
                                          } rounded-full`}
                                        />
                                      )
                                    }
                                  </div>
                                  <p
                                    className={`text-2xl font-extrabold uppercase  ${
                                      (item as any).aprovacao === "sim"
                                        ? "text-green-500"
                                        : (item as any).aprovacao === "nao"
                                        ? "text-red-500"
                                        : "text-yellow-400"
                                    }`}
                                  >
                                    {/* @ts-ignore */}
                                    {item.nome}
                                  </p>
                                </div>

                                <p
                                  className={`text-2xl font-extrabold uppercase ${
                                    (item as any).aprovacao === "sim"
                                      ? "text-green-500"
                                      : (item as any).aprovacao === "nao"
                                      ? "text-red-500"
                                      : "text-yellow-400"
                                  }`}
                                >
                                  {/* @ts-ignore */}
                                  {item.aprovacao == "nao"
                                    ? "Não"
                                    : item.aprovacao}
                                </p>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      : []}
                  </TableBody>
                </Table>
              </div>
            </div>
          </div>
        )}

      <div>
        <Divider className="bg-gray-700 h-[18px]" />

        <div className="grid h-full w-full grid-cols-3 ">
          <div className="flex flex-col h-full">
            <div className="p-1 border-1 border-gray-700 h-full text-5xl text-center font-bold text-gray-50">
              {format(new Date(), "HH:mm:ss")}
            </div>
            <div className="p-1 border-1 border-gray-700 h-full text-2xl text-center font-normal text-gray-50">
              {format(new Date(), "dd/MM/yyyy")}
            </div>
          </div>

          <div className="flex h-full w-full flex-row justify-between">
            <div className="flex h-full w-full flex-col justify-between">
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-green-500">
                {quantidadeVotosSim}
              </div>
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-green-500">
                SIM
              </div>
            </div>
            <div className="flex h-full w-full flex-col justify-between">
              <div className="p-1  h-full w-full  border-1 border-slate-600 text-3xl text-center font-bold text-red-500">
                {quantidadeVotosNao}
              </div>
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-red-500">
                NÃO
              </div>
            </div>
            <div className="flex h-full w-full flex-col justify-between">
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-yellow-400">
                {quantidadeVotosAbst}
              </div>
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-yellow-400">
                ABST
              </div>
            </div>
          </div>

          <div className=" h-full w-full flex flex-col justify-between">
            <div className="p-1 w-full flex flex-row justify-between px-16 border-1 border-slate-600 h-full text-3xl text-center font-bold text-white">
              <span className="text-2xl font-semibold ">PARLAMENTARES</span>
              <span className="text-2xl font-semibold ">
                {presencaParlamentares.length}
              </span>
            </div>
            <div className="p-1 w-full flex flex-row justify-between px-16 border-1 border-slate-600 h-full text-3xl text-center font-bold text-red-500">
              <span className="text-2xl font-semibold ">AUSENTES</span>
              <span className="text-2xl font-semibold ">
                {presencaParlamentares.length -
                  presencaParlamentares.filter(
                    (item) => (item as any).presenca === true
                  ).length}
              </span>
            </div>
            <div className="p-1 h-full w-full flex flex-row justify-between px-16 border-1 border-slate-600 text-2xl text-center font-normal text-blue-400">
              <span className="text-2xl font-bold ">PRESENTES</span>
              <span className="text-2xl font-bold ">
                {
                  presencaParlamentares.filter(
                    (item) => (item as any).presenca === true
                  ).length
                }
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
